import React, { useState, useEffect } from 'react';
import { useLayers, initVisible, Visible, LayerToolOptions } from './layerTool';
import { Image } from './Image';
import { ImageResizer } from './ImageResizer';
import { Menu } from './Menu';
import { Atlas } from './Atlas';
import { Loader } from './Loader';
import { LayersButton } from './LayersButton';
import './styles.scss';

export const MediaWrapper: React.FC<{ layerTool: LayerToolOptions }> = ({
  layerTool,
  children,
}) => {
  const loadLayersUrl = layerTool.loadLayersUrl;

  const { layersData, error } = useLayers(loadLayersUrl);

  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    setEnabled(false);
  }, [loadLayersUrl]);

  const [visible, setVisible] = useState<Visible>({});
  useEffect(() => {
    const newVisible = initVisible(layersData?.layers ?? []);
    setVisible(newVisible);
  }, [layersData]);

  return (
    <div className="gen-layers-layout">
      {!enabled && <LayersButton setEnabled={setEnabled} onClick={layerTool.layersButtonOnClick} />}

      {enabled ? (
        layersData ? (
          <>
            <div className="gen-layers-layout__image-container">
              <Atlas atlasUrl={layerTool.viewUrlFn(layersData.atlas.s3_key)} />
              <ImageResizer layersData={layersData}>
                <Image layersData={layersData} visible={visible} />
              </ImageResizer>
            </div>
            <Menu
              layersData={layersData}
              setEnabled={setEnabled}
              visible={visible}
              setVisible={setVisible}
              downloadAvailable={layerTool.downloadAvailable}
              downloadUrlFn={layerTool.downloadUrlFn}
              downloadGroupUrlFn={layerTool.downloadGroupUrlFn}
              downloadOnClick={layerTool.downloadOnClick}
            />
          </>
        ) : (
          <div className="gen-layers-status">
            <Loader
              text={error ? 'Layers have not been loaded' : 'Loading layers'}
              loading={!error}
            />
          </div>
        )
      ) : (
        children
      )}
    </div>
  );
};
